import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import StoreService from 'scaleflow/services/store';

class SettingsGroupsGroupRoute extends Route {
  @service declare store: StoreService;

  model({ group_id }: { group_id: string }) {
    return this.store.findRecord('group', group_id);
  }
}

export default instrumentRoutePerformance(SettingsGroupsGroupRoute);
